module.exports = __webpack_public_path__ + "static/media/logoSmall.9523fd38.svg";